import styled from "styled-components";
import { GoPrimitiveDot } from "react-icons/go";
import { Container } from "../../../components/navbar/Nav.styles";
import { Button } from "../../home/components/HeroSession.js/HeroSession.styles";

const AutoLoan = () => {
  return (
    <ContainerProd>
      <Wrapper>
        <div>
          <div className="web__content">
            <h1>
              Get that car with <span className="beta__life">Auto Loan</span>
            </h1>
            <p>
              This product is driven to assist people in buying their desired
              cars. It will also be driven by target savings such that the
              beneficiary would have saved up to 30%-50% of the cost of the
              vehicle over a period of time.
            </p>
          </div>
          <img
            className="first__image"
            style={{ marginTop: "1rem" }}
            src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636145/invest-trust/Rectangle_49_3_mnzwzh.png"
            alt="betalife"
          />

          <h2>Features</h2>
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Auto loan duration of 6-24months.</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Contribute as low as 30% towards the purchase. </span>
          </BenefitItem>
          <div className="start__saving">
            <Button to="/auto">Start Saving</Button>
          </div>
          <div style={{ marginTop: "4rem" }}>
            <img
              className="web__view"
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636146/invest-trust/Rectangle_9123_3_kmtojt.png"
              alt="betalife"
            />
          </div>
        </div>

        <BenefitComp>
          <div>
            <div className="mobile__content">
              <h1>
                Get that car with <span className="beta__life">Auto Loan</span>
              </h1>
              <p>
                This product is driven to assist people in buying their desired
                cars. It will also be driven by target savings such that the
                beneficiary would have saved up to 30%-50% of the cost of the
                vehicle over a period of time.
              </p>
            </div>
            <div>
              <img
                src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651540954/invest-trust/Rectangle_9119_vsjlp3.png"
                alt="betalife"
              />
            </div>
          </div>
          <h2>Benefits</h2>
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Access to comprehensive car insurance</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Flat competitive rate of 3% monthly.</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Auto loan amount up to #5Million</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Auto loan is ready within 48hours</span>
          </BenefitItem>
          <div style={{ marginTop: "4rem" }}>
            <img
              className="mobile__view"
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636146/invest-trust/Rectangle_9123_3_kmtojt.png"
              alt="betalife"
            />
          </div>
        </BenefitComp>
      </Wrapper>
    </ContainerProd>
  );
};

export default AutoLoan;
export const ContainerProd = styled(Container)`
  transform: translateY(-8rem);
  background-color: #dbdbf9;
`;

export const Wrapper = styled.div`
  .web__view {
    display: none;
  }
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 43px;
  margin-bottom: 2rem;

  img {
    max-width: 100%;
  }

  div:nth-of-type(1) {
    // border: 3px solid teal;
  }

  div:nth-of-type(1) h1 {
    margin-top: 0rem;
    font-family: "Futura";
    font-size: 2.7rem;
    font-weight: 200;
    margin-bottom: 1rem;
    line-height: 56px;
  }
  div:nth-of-type(1) p {
    margin-top: 0rem;
    font-size: 20px;
    padding-right: 2.5rem;
    // border: 3px solid red;
  }

  .beta__life {
    color: ${({ theme }) => theme.colors.secondary};
  }

  .start__saving {
    margin-top: 4rem;
  }
  .start__saving a {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
  }
  .bullet__point {
    font-size: 32px;
    color: #1b20e5;
  }
  .bullet__point__benefit {
    font-size: 32px;
    color: #1b20e5;
    margin-top: -1.5rem;
    margin-left: 0.1rem;
  }

  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    .start__saving {
      display: flex;
      justify-content: center;
    }
    .web__content {
      display: none;
    }
    .web__view {
      display: inline-block;
    }
    div:nth-of-type(1) h1 {
      font-size: 3rem;
      text-align: center;
    }
    .beta__life {
      display: block;
    }
    div:nth-of-type(1) p {
      font-size: 20px;
      padding-right: 0rem;
      text-align: center;
    }
  }
  @media screen and (max-width: 579px) {
    grid-template-columns: 1fr;
    .first__image {
      transform: translateY(-4rem);
    }
    .web__features {
      transform: translateY(-8rem);
      margin-bottom: -4rem;
      // border: 2px solid red;
    }
    div:nth-of-type(1) h1 {
      font-size: 2rem;
      text-align: center;
      line-height: 40px;
    }
    .bullet__point {
      margin-top: 0.4rem;
      font-size: 16px;
      color: #1b20e5;
    }
    .bullet__point__benefit {
      font-size: 16px;
      color: #1b20e5;
      margin-top: 0.4rem;
      margin-left: 0.1rem;
    }
  }
`;

export const BenefitComp = styled.div`
  div: nth-of-type(2);
  .mobile__content {
    display: none;
  }
  .mobile__view {
    display: inline-block;
  }
  div: nth-of-type(2);
  @media screen and (max-width: 991px) {
    grid-row-start: 1;
    grid-row-end: 3;
    .mobile__content {
      display: block;
    }
    .mobile__view {
      display: none;
    }
  }
  @media screen and (max-width: 579px) {
  }
`;

export const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  // width: 577px;

  .product__dot {
    color: ${({ theme }) => theme.colors.secondary};
    background-color: ${({ theme }) => theme.colors.secondary};
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
  span {
    font-size: 20px;
  }
  @media screen and (max-width: 991px) {
  }
  @media screen and (max-width: 579px) {
    align-items: flex-start;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  span {
    font-size: 20px;
    padding-right: 2rem;
  }
`;
